import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-close',
  templateUrl: './icon-close.component.html',
  styleUrls: ['./icon-close.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCloseComponent {}
